'use strict';
module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);



//////////////////
// WEBPACK FOOTER
// ../node_modules/query-string/node_modules/strict-uri-encode/index.js
// module id = ../node_modules/query-string/node_modules/strict-uri-encode/index.js
// module chunks = 5